<template>
  <div class="section overflow-hidden position-relative min-height" id="wrapper">

    <!-- Page Content Wrapper Start -->
    <div class="page-content-wrapper padding-left-0">
      <div class="container-fluid custom-container">

        <!-- Message Start -->
        <div class="" >
          <div class="message-content">
            <h3>Manage Testimonials:</h3>
          </div>
        </div>
        <!-- Message End -->

        <!-- Your Packages Start -->
        <div class="section section-padding mt-n10 padding-top-50">
          asdas 
        </div>
        <!-- Packages End -->

      </div>
    </div>
    <!-- Page Content Wrapper End -->
  </div>
</template>

<script>


export default {
  name: 'ManageTestimonials',
}
</script>